class Monitoring.Models.ArrivalAlert extends Backbone.Model
  urlRoot: '/monitoring/arrival_alerts'

  defaults:
    name: ''
    description: ''
    recipients: []
    active: true
    start_date: undefined
    end_date: null
    updated_at: undefined
    last_updated_by: undefined
    topics: []
    tags: []
    groups: []
    subtypes: []
    ownership: 'all-content'
    authors: []
    excluded_authors: []
    locations: []
    mentions: [],
    min_followers: null
    news_sources: []
    sentiments: []

  validateFields: ->
    invalidEmails = _.filter(@get('recipients'), (recipient) => not @isEmail(recipient))
    if invalidEmails.length > 0
      return "#{I18n.t('monitoring.arrival_alerts.validations.invalid_email')}: #{invalidEmails[0]}"
    else
      unless @get('min_followers') == null or @get('min_followers') == '' or (@get('min_followers') + "").match(/^\d+$/)
        return I18n.t('monitoring.arrival_alerts.validations.invalid_followers')
    @validateLengthOfStrings()

  validateLengthOfStrings: ->
    stringFields = [
      'recipients',
      'topics',
      'tags',
      'groups',
      'subtypes',
      'authors',
      'excluded_authors',
      'mentions',
      'news_sources',
      'locations'
    ]

    ret = "VALID"

    _.each(stringFields, (field) =>
      string = @get(field).join(', ')
      if string.length > 2000
        translationKey = "monitoring.arrival_alerts.fields.#{field}"
        ret = "#{I18n.t('monitoring.arrival_alerts.validations.too_many')} #{I18n.t(translationKey)}!"
    )

    return ret

  isEmail: (string) ->
    string.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)

  getTopicIdsAsIntegers: ->
    _.map(@get('topics'), (id) -> parseInt(id))

  getFormattedStartDate: (format = 'YYYY-MM-DD') ->
    return '' unless @get('start_date')
    Date.create(@get('start_date')).format(format)

  getFormattedEndDate: (format = 'YYYY-MM-DD') ->
    return '' unless @get('end_date')
    Date.create(@get('end_date')).format(format)

  getFormattedUpdatedAt: (format = 'YYYY-MM-DD') ->
    return '' unless @get('updated_at')
    Date.create(@get('updated_at')).format(format)


class Monitoring.Collections.ArrivalAlertsCollection extends Backbone.Collection
  model: Monitoring.Models.ArrivalAlert
